import { render, staticRenderFns } from "./AccountCustomerSearchDetails.vue?vue&type=template&id=3d2b5bca"
import script from "./AccountCustomerSearchDetails.vue?vue&type=script&lang=ts"
export * from "./AccountCustomerSearchDetails.vue?vue&type=script&lang=ts"
import style0 from "./AccountCustomerSearchDetails.vue?vue&type=style&index=0&id=3d2b5bca&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports